<template>
  <div>
    <section class="container-fluid my-4 col-md-10 offset-md-2">
      <h4 class="my-4">
        Modelos de <strong>Documentos</strong>
      </h4>

      <div class="mb-3">
        <button
          class="btn btn-success btn-sm"
          @click="$router.push({ name: 'document-template-register' })"
        >
          + Novo Modelo
        </button>
      </div>

      <table class="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>Nome</th>
            <th>Tipo</th>
            <th>Arquivo (view)</th>
            <th>Orientação</th>
            <th>Ativo</th>
            <th width="140px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>
              <span
                class="badge"
                :class="{
                  'bg-primary': item.type === 'certificate',
                  'bg-warning text-dark': item.type === 'history',
                }"
              >{{ item.type }}</span>
            </td>
            <td><code>{{ item.view_name }}</code></td>
            <td>{{ item.paper_orientation }}</td>
            <td>
              <span
                class="badge"
                :class="item.active ? 'bg-success' : 'bg-secondary'"
              >{{ item.active ? "Sim" : "Não" }}</span>
            </td>
            <td>
              <button
                class="btn btn-sm btn-outline-primary me-1"
                @click="$router.push({ name: 'document-template-edit', params: { id: item.id } })"
                title="Editar"
              >
                Editar
              </button>
              <button
                class="btn btn-sm"
                :class="item.active ? 'btn-outline-danger' : 'btn-outline-success'"
                @click="toggleActive(item)"
                :title="item.active ? 'Desativar' : 'Ativar'"
              >
                {{ item.active ? "Desativar" : "Ativar" }}
              </button>
            </td>
          </tr>
          <tr v-if="!items.length">
            <td colspan="7" class="text-center text-muted">
              Nenhum modelo cadastrado.
            </td>
          </tr>
        </tbody>
      </table>

      <Pagination :source="pagination" @navigate="navigate" />
    </section>
  </div>
</template>

<script>
import api from "@/services";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "DocumentTemplateList",
  components: { Pagination },
  data() {
    return {
      items: [],
      pagination: {},
    };
  },
  methods: {
    async getItems(page = 1) {
      await api.get(`/document-templates?perPage=100&page=${page}`).then((res) => {
        this.items = res.data.data;
        this.pagination = res.data.meta || res.data.pagination || {};
      });
    },
    navigate(page) {
      this.getItems(page);
    },
    async toggleActive(item) {
      try {
        const res = await api.put(`/document-templates/${item.id}`, {
          ...item,
          active: !item.active,
        });
        Toast.fire(res.data.message, "", "success");
        this.getItems();
      } catch (error) {
        Toast.fire(error.response?.data?.message || "Erro", "", "error");
      }
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>
